import { Component, ElementRef, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { GetColleagueResponse } from './getcolleagueresponse';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { UpdateColleagueRequest } from './updatecolleaguesrequest';
import { UpdateColleagueResponse } from './updatecolleagueresponse';
import { Colleague } from './colleague-photo';
import { ApiRequestService } from '../shared/api-request-service';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../toastmessage/toastmessage.service';
import { TranslationService } from '../translation/translation.service';
import { HttpError } from '../shared/httperror';
import { UploadFileResponse } from '../banners/uploadfileresponse';
import { MatdialogService } from '../matdialog/matdialog.service';
import { DeleteColleaguepopupComponent } from './delete-colleaguepopup/delete-colleaguepopup.component';
import { MetaService } from '../meta/meta.service';


@Component({
    selector: 'app-colleagues',
    templateUrl: './colleagues.component.html',
    styleUrls: ['./colleagues.component.scss']
})
export class ColleaguesComponent implements OnInit {

    colleagues: Colleague[] = [];

    colleagueUrl = '/websiteconfigurator/get-colleagues';

    configuratorBaseUrl = '';

    colleagueForm?: FormGroup;

    updateColleaguesUrl = '/admin/update-colleagues';

    @ViewChildren("fileCovers") private fileCoversInput!: QueryList<ElementRef>;
    fileCoverList: File[] | null = null;

    uploadFileToAnExistingFolderUrl = '/admin/updatefile';

    fileBaseUrl = '';

    get items() {
        return this.colleagueForm?.get('items') as FormArray;
    }

    constructor(
        @Inject('CONFIGURATOR_BASE_URL') private _configuratorBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        private _toastMessageService: ToastmessageService,
        @Inject('FILE_MANAGER_URL') private _fileManagerUrl: string,
        private _translateService: TranslationService,
        private _fb: FormBuilder,
        private _matDialogService: MatdialogService,
        private _metaService: MetaService

    ) {

        this.configuratorBaseUrl = _configuratorBaseUrl;

        this.fileBaseUrl = _fileManagerUrl;

        this._metaService.settingUpOgUrl();

        this.createColleagueFormArray();
    }

    ngOnInit(): void {
        this.getColleagues();
    }

    getColleagues() {
        this._apiRequestService
            .sendRequest<{}, GetColleagueResponse>(this.configuratorBaseUrl, true, {}, true, this.colleagueUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();

                    });
                })
            )
            .subscribe((response: GetColleagueResponse) => {
                this.colleagues = response.colleagueList as Colleague[];
                this.colleagueForm = this._fb.group({
                    items: this._fb.array(this.colleagues!.map(colleague => this._fb.group(colleague)))
                });
            });
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    updateColleagues() {
        const updateColleaguesRequest: UpdateColleagueRequest = {
            colleagueList: this.items.value as Colleague[]
        }

        this._apiRequestService
            .sendRequest<UpdateColleagueRequest, UpdateColleagueResponse>(this.configuratorBaseUrl, true, updateColleaguesRequest, true, this.updateColleaguesUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();

                    });
                })
            )
            .subscribe((response: UpdateColleagueResponse) => {
                this._toastMessageService.displayToastMessage(TOAST_STATE.success, response.responseMessage!, MAT_ICON.success);
                this.dismissError();
                this.updateFiles();
            });
    }

    createColleagueFormArray() {
        this.colleagueForm = this._fb.group({
            items: this._fb.array([this.colleagueForm])
        });

    }
    updateFile(file: File, folderName: string, index: number) {
        this._apiRequestService.updateFile(file, folderName, true, true, this.fileBaseUrl, this.uploadFileToAnExistingFolderUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage), MAT_ICON.error);
                        this.dismissError();


                    });
                })
            )
            .subscribe((response) => {
                const uploadFileResponse = response as UploadFileResponse;
                if (uploadFileResponse.downloadUri) {
                    this._toastMessageService.displayToastMessage(
                        TOAST_STATE.success,
                        'Sikeres fájl feltöltés ' + uploadFileResponse.fileName!,
                        MAT_ICON.success
                    );
                    this.dismissError();
                    if (index === this.colleagues.length - 1) {
                        window.location.reload();
                    }
                }

            });
    }

    onChange(event: Event, colleague: Colleague) {
        const target = event.target as HTMLInputElement;
        //this.fileCover = target.files![0];
        if (target.files![0].name.split('.').pop() === 'jpg' || 'png' || 'JPEG' || 'jpeg') {
            colleague.fileCover = target.files![0];
        }
        else {
            colleague.fileCover = null;
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, 'Kérem ".jpg" vagy ".png" kiterjesztésű fájlt töltsön fel!', MAT_ICON.warning);
            this.dismissError();
        }
    }

    updateFiles() {
        this.colleagues.forEach((colleague, index) => {
            if (colleague.fileCover?.name) {
                const folderName = colleague.imageUrl!.split('/').pop() as string;

                this.updateFile(colleague.fileCover!, folderName, index);
            }

        })


    }

    openDeleteColleaguePopup(colleague: Colleague) {
        this._matDialogService.openPopupWithData(colleague, DeleteColleaguepopupComponent);
    }
}
